import { useMutation } from '@connectrpc/connect-query'
import { describeVoucher } from '@jotta/grpc-connect-openapi/signupQuery'
import { publicTransport } from '../transport'

export function useDescribeVoucher() {
  return useMutation(describeVoucher, {
    transport: publicTransport,
  })
}
